module.exports = __webpack_public_path__ + "static/media/mobileScreenshot04.000b3cb4.jpg";